module.exports = __webpack_public_path__ + "img/slide-30.85769152.jpeg";